<template>
  <Section
    :id="id"
    :header="t('common.relatedParam', { param: t('documents.documents', 2) })"
    :loading="relatedDocuments.loading"
    class="related-documents-section"
    data-class="related-documents-container flex flex-gap-1 flex-column"
  >
    <RelatedDocumentCard
      v-for="document in relatedDocuments.data"
      :key="document.id"
      :document="document"
      previewable
    />
    <p v-if="hasLoaded && !relatedDocuments.data?.length">
      {{
        t('common.noParam', {
          param: t('common.relatedParam', {
            param: t('documents.documents', 2),
          }),
        })
      }}
    </p>
  </Section>
</template>

<script lang="ts" setup>
import { defineAsyncComponent, ref, toRefs, watch } from 'vue';
import { useI18n } from 'vue-i18n';

import { useRelatedDocuments } from '@/composables';
import { useParentEntityStore } from '@/stores/ParentEntity';

import Section from '@rygen/rygen-ui/components/ui/Section.vue';

const RelatedDocumentCard = defineAsyncComponent(
  // lazy load document cards so that the huge pdfjs files are lazy loaded
  () => import('@rygen/rygen-ui/components/document/RelatedDocumentCard.vue'),
);

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();
const { loadRelatedDocuments, relatedDocuments } = useRelatedDocuments();
const { parentEntity } = useParentEntityStore();

const hasLoaded = ref(false);

watch(
  () => parentEntity.value?.id,
  async (newVal: number | null | undefined) => {
    if (newVal) {
      hasLoaded.value = false;
      await loadRelatedDocuments();
      hasLoaded.value = true;
    }
  },
  { deep: true, immediate: true },
);
</script>
